<div class="row">
    
    <div class="col-12">

        <div class="card">

            <div class="card-header">
                <div class="title"> Настройка формулы</div>
                <div class="tools">
                    <!-- <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
                        <span aria-hidden="true">&times;</span>
                    </button> -->
                    <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss(false)">
                        <svg-icon  src="/assets/images/icons/close.svg" [stretch]="true"
                        [svgStyle]="{'width.px':20, 'height.px':20}"></svg-icon>
                    </button>
                </div>
            </div>

            <div class="card-body">

                <div class="row">

                    <form class="col-12 form" [formGroup]="form" autocomplete="off">

                        <div formArrayName="formula_fields">

                            <div *ngFor="let item of form.get('formula_fields')['controls']; let i = index;">

                                <div class="row" [formGroupName]="i">

                                    <div class="col-4">
                                        <div class="form-group">
                                            <label class="filter-label" for="type"> Тип</label>
                                            <ng-select id="format" 
                                            class="custom" 
                                            clearAllText="{{ 'CLEAR' | translate }}"
                                            notFoundText="{{ 'NO_DATA' | translate }}" 
                                            bindLabel="name"
                                            formControlName="type_field" 
                                            appendTo="body" 
                                            [selectOnTab]="true" 
                                            (change)="getTypesListener(i, true)"
                                            [items]="types[i]">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div title="{{item.name}}">{{item.name}}</div>
                                                </ng-template>
                                            </ng-select>
                                            <div *ngIf="errorMessages">
                                                <div *ngFor="let item of errorMessages.type_field">
                                                    <div class="text-error" *ngIf="validation(['formula_fields', i, 'type_field'], item.type)">
                                                        {{ item.message | translate: item.options }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-4">
                                        <div class="form-group">

                                            <label class="filter-label" for="value"> Значение</label>
                                                
                                            <input (input)="getActionsListener(i)" *ngIf="actionType[i] == 'TEXTBOX'" type="text" class="form-control" id="value" formControlName="value_type">

                                            <input (input)="getActionsListener(i)" *ngIf="actionType[i] == 'NUMERIC'" type="number" class="form-control" id="value" formControlName="value_type">
                                           
                                            <ng-select 
                                            *ngIf="actionType[i] == 'COMBOBOX'"
                                            id="action" 
                                            class="custom" 
                                            clearAllText="{{ 'CLEAR' | translate }}"
                                            notFoundText="{{ 'NO_DATA' | translate }}" 
                                            bindLabel="name"
                                            formControlName="value_type" 
                                            appendTo="body" 
                                            [selectOnTab]="true"
                                            (change)="getActionsListener(i)"
                                            [items]="actions[i]">
                                                <ng-template ng-option-tmp let-item="item">
                                                    <div title="{{item.name}}">{{item.name}}</div>
                                                </ng-template>
                                            </ng-select>
                                            <div *ngIf="errorMessages">
                                                <div *ngFor="let item of errorMessages.value_type">
                                                    <div class="text-error" *ngIf="validation(['formula_fields', i, 'value_type'], item.type)">
                                                        {{ item.message | translate: item.options }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div [ngClass]="{'col-3': form.get('formula_fields').value.length > 1, 'col-4': form.get('formula_fields').value.length == 1}">
                                      
                                        <label class="filter-label" for="lang"> Язык:</label>
                                        <ng-select 
                                        id="lang" 
                                        class="custom" 
                                        clearAllText="{{ 'CLEAN' | translate }}" 
                                        notFoundText="{{ 'NO_DATA' | translate }}" 
                                        bindLabel="name"
                                        bindValue="id"
                                        [multiple]="false" 
                                        formControlName="lang_code" 
                                        [items]="langs"
                                        groupBy="attribute_group_name" 
                                        appendTo="body"
                                        [selectOnTab]="true"
                                        [readonly]="!readonly[i]">
                                            <ng-template ng-option-tmp let-item="item">
                                                <div title="{{item.name}}">{{item.name}}</div>
                                            </ng-template>
                                        </ng-select>

                                        <div *ngIf="errorMessages">
                                            <div *ngFor="let item of errorMessages.value">
                                                <div class="text-error" *ngIf="validation(['formula_fields', i, 'value'], item.type)">
                                                    {{ item.message | translate: item.options }}
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    <div class="col-1 remove-filter-field" *ngIf="form.get('formula_fields').value.length > 1">
                                        <button type="button" class="btn btn-danger" (click)="removeFormulaField(i)">
                                            <i class="bi bi-trash"></i>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>

                    <a class="col-2 add-field" for="add-field" (click)="addFormulaFields()">
                        <i class="bi bi-plus-circle"></i>Добавить элемент
                    </a>

                    <div *ngIf="lastElem == 'OPERATOR'" class="alert alert-warning" role="alert">
                       При создании формулы, поле с типом "оператор" не может быть последним
                    </div>

                </div>
            </div>

            <div class="modal-footer btn-box">
                <button type="button" class="btn btn-primary btn-sm" (click)="onSave()" [disabled]="form.invalid || lastElem == 'OPERATOR'">{{ 'SAVE'| translate }}</button>
                <button type="button" class="btn btn-light btn-sm" (click)="activeModal.dismiss(false)">{{ 'CLOSE' | translate }}</button>
            </div>

        </div>
    </div>
</div>